import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form';

class EditGroup extends Component {
  render() {
    const { handleSubmit, isSending } = this.props;
    return (
      <form className="edit-student-form"
        onSubmit={handleSubmit}
      >
      <div>
          <p>
              W tym oknie możesz zmienić status, płatność i funkcję dla grupy użytkowników.
              Aby zmienić którąś wartość zaznacz odpowiadający checkbox i wpisz nową wartość
          </p>
         <p>
            <label>Płatność</label>
             <span>
                 <Field
                     name="paymentsInfo.isUpdated"
                     component="input"
                     type="checkbox"
                 />
                <Field
                    name="paymentsInfo.value"
                    component="input"
                />
             </span>
        </p>
        <p>
            <label>Status</label>
            <span>
                <Field
                    name="statusStudent.isUpdated"
                    component="input"
                    type="checkbox"
                />
                <Field
                    name="statusStudent.value"
                    component="input"
                />
            </span>
        </p>
        <p>
            <label>Funkcja</label>
            <span>
                 <Field
                     name="studentFunction.isUpdated"
                     component="input"
                     type="checkbox"
                 />
                <Field
                    name="studentFunction.value"
                    component="input"
                />
            </span>
        </p>
      </div>
        <div>
          <button disabled={isSending}>Zaktualizuj wszystkich</button>
        </div>
      </form>
    )
  }
};
// {
//     "_id": {
//         "$oid": "5ab6c7c64e2fc8139d713b14"
//     },
//     "index": "238487",
//     "firstName": "Aleksandra",
//     "surname": "Waszkowski",
//     "mail": "Aleksandra.Waszkowski@gmail.com",
//     "department": "w1",
//     "sex": "mezczyzna",
//     "statusStudent": null,
//     "studentFunction": "uczestnik",
//     "paymentsInfo": null,
//     "transport": null,
//     "room": null,
//     "statement": null,
//     "tShirtSize": "xl",
//     "preferDepartures": "17:00",
//     "ice": {},
//     "receivedMail": null,
//     "recordData": 1521928128996
// }
export default reduxForm({
    form: 'editGroup'
  })(EditGroup);



// WEBPACK FOOTER //
// ./src/modules/Admin/components/EditGroup.js